import { takeEvery } from 'redux-saga/effects';

import * as messagesPageActions from 'store/modules/messagesPage';
import { load } from './utils';

export default function* listenLoad() {
  yield takeEvery(messagesPageActions.load.toString(), load);
}
